import { render, staticRenderFns } from "./TagImage.vue?vue&type=template&id=2a91d000&lang=pug&"
import script from "./TagImage.vue?vue&type=script&lang=js&"
export * from "./TagImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports